import { NavLink } from "react-router-dom";
import Reveal from "../../../shared/design/Reveal";
import CtaImg from "../../../assets/home-cta-2.jpg";

const Cta = () => {
  return (
    <div className="mx-auto max-w-[1320px] px-6 pb-[70px] md:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[28px] px-8 py-14 text-white md:px-14 md:py-[70px]">
          <img
            src={CtaImg}
            alt="Expedition"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[rgba(19,58,69,0.9)] to-[rgba(19,58,69,0.35)]" />
          <div className="relative max-w-[560px]">
            <h2 className="mb-4 font-serif text-[34px] font-normal leading-[1.05] md:text-[46px]">
              Your next horizon is
              <br />
              one click away.
            </h2>
            <p className="mb-[30px] text-[17px] leading-relaxed text-[#dde7e3]">
              Browse our expeditions, pick a departure, and let us handle the
              rest. Free cancellation up to 30 days out.
            </p>
            <div className="flex flex-wrap gap-4">
              <NavLink
                to="/tours"
                className="rounded-full bg-primary-500 px-7 py-[15px] text-[15.5px] font-bold text-ink transition-colors hover:bg-primary-300"
              >
                Explore tours →
              </NavLink>
              <NavLink
                to="/contact"
                className="rounded-full border-[1.5px] border-white/60 px-7 py-[15px] text-[15.5px] font-semibold text-white transition-colors hover:bg-white/10"
              >
                Talk to a guide
              </NavLink>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  );
};

export default Cta;
